import { css } from '@emotion/css';

export const blue100HoverBackground = css`
  :focus:not(:active),
  :hover:not(:active) {
    background-color: var(--blue-100);
  }
`;
